import axiosInstance from '@/api/axiosInstance';
export default {
  namespaced: true,
  state: { categories: [], subspecialties: [], categoryOptions: [], reload: false },
  mutations: { SET(state, { key, data }) { state[key] = data; } },
  actions: {
    async list({ commit }, { type, params }) { const r=await axiosInstance.get(`/catalogs/${type}_list`, { params }); const key=type==='categories'?'categories':'subspecialties'; commit('SET',{key,data:r.data.data.items}); return r.data.data.items; },
    async options({ commit }) { const r=await axiosInstance.get('/catalogs/categories_options'); commit('SET',{key:'categoryOptions',data:r.data.data.categories}); },
    async save(_, { type, data }) { return (await axiosInstance.post(`/catalogs/${type}_save`, data)).data; },
    async remove(_, { type, id }) { return (await axiosInstance.delete(`/catalogs/${type}_destroy/${id}`)).data; },
  },
};
